import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../translation/translation_container';
import TextInput from '../form/floating_label/text_input';
import PostcodeAutocomplete, { showAutoCompletePostcodeSelector } from '../PostcodeAutocomplete';
import getTranslatedText from '../../helper/get_translated_text';

export const PostcodeLightBoxContent = (props) => {
    const showPostcodeAndCitySelector = showAutoCompletePostcodeSelector(props.store);
    return (
        <div className="postcode-light-box__content postcode-light-box-content">
            <form className="postcode__form" onSubmit={props.onSubmit}>
                {
                    !showPostcodeAndCitySelector && <TranslationContainer
                        targetProperties={{
                            label: { translationKey: 'postcode-form-postcode-input-label' },
                        }}
                    >
                        <TextInput
                            name="postcode"
                            value={props.postcode}
                            onChange={props.onChange}
                            label="will-be-replaced"
                            errorText={props.postcodeInvalidMessage}
                            highlight={!props.postcode}
                            invalid={props.postcodeInvalid}
                        />
                    </TranslationContainer>
                }

                {
                    showPostcodeAndCitySelector && <PostcodeAutocomplete name="postcode"
                        value={props.postcode}
                        onChange={props.onChange}
                        selectSuggestion={props.selectPostcodeSuggestion}
                    >
                        <TextInput
                            name="postcode"
                            value={props.postcode}
                            onChange={props.onChange}
                            label={getTranslatedText('postcode-form-postcode-autosuggest-label')}
                            errorText={props.postcodeInvalidMessage}
                            highlight={!props.postcode}
                            invalid={props.postcodeInvalid}
                            autoComplete="off"
                        />
                    </PostcodeAutocomplete>
                }
                <TranslationContainer
                    translationKey="postcode-form-submit"
                    targetProperty="value"
                >
                    <input
                        type="submit"
                        className="notify-me__submit"
                        disabled={props.postcodeInvalid}
                    />
                </TranslationContainer>
            </form>
        </div>
    );
}

PostcodeLightBoxContent.propTypes = {
    visible: PropTypes.bool.isRequired,
    showError: PropTypes.bool.isRequired,
    postcode: PropTypes.string.isRequired,
    postcodeInvalid: PropTypes.bool.isRequired,
    postcodeInvalidMessage: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};
